import React, { useEffect } from 'react';

import ErrorIcon from '@/assets/icons/error-icon.svg';

import { isBrowser } from '../../../helpers/is-browser';
import { useGetLibraryConstantsDictionary } from '../../../hooks/use-get-library-constants-dictionary';
import { IContentfulImage } from '../../../interfaces/contentful-image.interface';
import Button from '../../ui/button/button';
import {
  useGetLibraryConstantsDictionaryData,
  useIsMPLivliFamily,
} from '@/providers/ConfigProvider';
import { useUser } from '@/providers/UserProvider';

interface DynamicOfferRedemptionProps {
  className?: string;
  handleClose: () => void;
  errorMessage?: string;
  node_locale: string;
  tenantDetails: {
    offerName?: string;
    tenantName?: string;
    tenantLogo?: IContentfulImage;
  };
  contentful_id?: string;
}

export const OfferRedemptionErrorScreen = ({
  className,
  handleClose,
  errorMessage,
  node_locale,
  tenantDetails,
  contentful_id,
}: DynamicOfferRedemptionProps) => {
  const dictionary = useGetLibraryConstantsDictionaryData();
  const { user } = useUser();
  const isLivliFamily = useIsMPLivliFamily();

  useEffect(() => {
    sendGtmEvent();
  }, []);

  const sendGtmEvent = () => {
    if (isBrowser && dataLayer) {
      dataLayer.push({
        event: 'offer_redemption',
        contentful_id: contentful_id,
        name: tenantDetails?.offerName,
        success: false,
        user_status: isLivliFamily ? (user ? 'logged_in' : 'guest') : undefined,
      });
    }
  };

  return (
    <div className="flex justify-between items-center flex-col h-full">
      <div>
        <h2 className="text-headingm font-title gap-4 text-neutral-grey-700">
          {errorMessage || dictionary?.dynamicOfferErrorMessageTitle}
        </h2>
        {!errorMessage && (
          <p className="text-bodyl mt-6">
            {dictionary?.dynamicOfferErrorMessageText}
          </p>
        )}
      </div>
      <div className="button-container flex flex-col gap-4 mt-6 w-full">
        <Button variant="primary" onClick={handleClose}>
          {dictionary?.close}
        </Button>
      </div>
    </div>
  );
};
